import React, { useState, useEffect } from "react";
import "./StatusCheck.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import CheckIcon from "../../../assets/images/Dashboard/statusCheck.svg";
import blackIcon from "../../../assets/images/blackCross.svg";

import CrossCheckIcon from "../../../assets/images/Dashboard/statuscross.svg";
import Binance from "../../../assets/images/binance.svg";
import Bybit from "../../../assets/images/bybit.svg";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { useNavigate } from "react-router-dom";
import InfoPopup from "../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import { toastify } from "../../../helpers/toast/toastify";

const leaderItems = [
  { id: 1, title: "Exchange is connected", icon: CrossCheckIcon },
  { id: 2, title: "Community set up", icon: CrossCheckIcon },
  // { id: 3, title: "Order your own app", icon: CrossCheckIcon },
  { id: 4, title: "Auto share your results", icon: CrossCheckIcon },
  { id: 5, title: "Get your monthly report by email", icon: CrossCheckIcon },
];

const memberItems = [
  { id: 1, title: "Exchange connected", icon: blackIcon },
  { id: 2, title: "Subscribed", icon: blackIcon },
  { id: 3, title: "Minimum Funding", icon: blackIcon },
  {
    id: 4,
    title: "Review Submitted",
    subtitle: "Submit Now >",
    icon: blackIcon,
  },
  {
    id: 5,
    title: "Security (Otp) Set up",
    subtitle: "Set up now >",
    icon: blackIcon,
  },
];

const StatusCheck = ({ user }) => {
  const [items, setItems] = useState([]);
  const [reviewSubmitted, setIsReviewSubmitted] = useState(false);
  const api = useApi();
  const navigate = useNavigate();

  const isMemberVerified =
    user?.role === "member" &&
    user?.onboarding?.connect &&
    user?.onboarding?.payment;
  const isOtpTrue=user?.security?.otp
  useEffect(() => {
    if (!user) return;

    const isLeader = user?.role === "leader";
    const baseItems = isLeader ? leaderItems : memberItems;

    let connectedExchange = "";
    if (user?.binanceCredentials?.isConnected) {
      connectedExchange = "Binance";
    } else if (user?.bybitCredentials?.isConnected) {
      connectedExchange = "Bybit";
    }

    const updatedItems =
      baseItems?.length > 0 &&
      baseItems
        .map((item) => {
          // Shared logic for exchange connection (item.id === 1)
          if (item.id === 1) {
            if (connectedExchange === "Binance") {
              return { ...item, icon: CheckIcon, logo: Binance };
            } else if (connectedExchange === "Bybit") {
              return { ...item, icon: CheckIcon, logo: Bybit };
            } else {
              const { logo, ...rest } = item;
              return rest;
            }
          }

          if (isLeader) {
            if (
              item.title === "Community set up" &&
              user?.onboarding?.community?.length
            ) {
              const smallestMonthlyFee = Math.min(
                ...(user?.leaderCommunity?.subscription?.map((plan) =>
                  parseFloat(plan.monthlyfee),
                ) || []),
              );
              return {
                ...item,
                icon: CheckIcon,
                subtitle: `From $${smallestMonthlyFee}/month`,
              };
            }
            if (item.title === "Order your own app" && user?.appOrder?.order) {
              return { ...item, icon: CheckIcon };
            }
            if (
              item.title === "Auto share your results" &&
              Object.keys(user?.leaderCommunity?.socials || [])?.length
            ) {
              return { ...item, icon: CheckIcon };
            }

            if (
              item.title === "Get your monthly report by email" &&
              user?.onboarding?.isVerified
            ) {
              return { ...item, icon: CheckIcon };
            }

            return item;
          }

          if (!isLeader) {
            const memberCommunity = user?.memberCommunities?.[0]?.community;

            if (
              item.title === "Subscribed" &&
              user?.memberCommunities?.[0]?.subscribed
            ) {
              const planType = user?.memberCommunities?.[0]?.planType;
              const foundSubscription = memberCommunity?.subscription?.find(
                (sub) =>
                  sub?._id?.toString() ===
                  user?.memberCommunities?.[0]?.subscription,
              );

              const subtitle =
                planType === "monthly"
                  ? `Tier $${foundSubscription?.monthlyfee}/month`
                  : `Tier $${foundSubscription?.yearlyfee}/year`;
              return { ...item, subtitle, icon: CheckIcon };
            }
            if (
              item.title === "Minimum Funding" &&
              user?.memberCommunities?.[0]?.subscribed
            ) {
              const foundSubscription = memberCommunity?.subscription?.find(
                (sub) =>
                  sub?._id?.toString() ===
                  user?.memberCommunities?.[0]?.subscription,
              );

              return {
                ...item,
                subtitle: `Required: $${foundSubscription?.minimumFunding}`,
                icon: CheckIcon,
              };
            }
            return item;
          }

          return item;
        })
        .sort((a, b) => {
          const isAChecked = a.icon === CheckIcon ? 1 : 0;
          const isBChecked = b.icon === CheckIcon ? 1 : 0;
          return isBChecked - isAChecked;
        });

    setItems(updatedItems || []);
  }, [user]);

  const specificUserReview = async () => {
    const response = await api("post", "communityReview/specificUserReview");
    if (response?.status) {
      setIsReviewSubmitted(true);
      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === 4 ? { ...item, icon: CheckIcon } : item,
        ),
      );
    }
  };

  useEffect(() => {
    if (user?.role === "member") specificUserReview();
  }, [user]);

  return (
    <div className="StatusBox">
      <div className="heading">
        <p className="title">Status</p>
      </div>
      <div className="sliderBox statusCheckPadding updatedStatusCard">
        <div className="slider-container">
          <Swiper
            spaceBetween={15}
            pagination={{ clickable: true }}
            centeredSlides={false}
            slidesPerView={5}
            loop={false}
            modules={[Pagination]}
            breakpoints={{
              320: { slidesPerView: 2 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 4 },
              1300: { slidesPerView: 5 },
              1440: { slidesPerView: 5 },
            }}
            className="my-swiper"
          >
            {items.map((item, index) => (
              <SwiperSlide key={item.id} className="slide">
                <div className="card">
                  {item.icon && (
                    <img
                      style={{
                        width: "30px",
                        height: "24px",
                      }}
                      className="icon red"
                      src={item.icon}
                      alt="Check Icon"
                    />
                  )}
                  <h3>{item.title}</h3>
                  {item.subtitle && (
                    <p
                      className="subtitle"
                      style={{
                        cursor:
                          (item.id === 4 &&
                          user?.role === "member" &&
                          !reviewSubmitted)||(item.id===5&&user?.role === "member" &&!isOtpTrue)
                            ? "pointer"
                            : "",
                      }}
                      onClick={() => {
                        if (
                          item.id === 4 &&
                          user.role === "member" &&
                          !reviewSubmitted
                        ) {
                          if (isMemberVerified)
                            navigate("/member/submitReview");
                          else
                            toastify(
                              "Please complete your onboarding steps first",
                              "error",
                            );
                        }
                        if (
                          item.id === 5 &&
                          user.role === "member" &&
                          !isOtpTrue
                        ) {
                          if (isMemberVerified)
                            navigate("/member/newAccountSettings");
                          else
                            toastify(
                              "Please complete your onboarding steps first",
                              "error",
                            );
                        }
                      }}
                    >
                      {item.subtitle}{" "}
                      {item.id === 3 && user.role === "member" && (
                        <InfoPopup
                          contentItems={[
                            {
                              text: "Minimum Funding",
                              type: "heading",
                            },
                            {
                              text: "If you don’t have the recommended minimum funds in your trading account your  copy trading will be paused until your trading account is funded accordingly. ",
                              type: "paragraph",
                            },
                          ]}
                        />
                      )}
                    </p>
                  )}
                  {item.logo && <img className="logo" src={item.logo} alt="" />}
                </div>
                {/* {index !== items.length - 1 && <div className="separator" />} */}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default StatusCheck;
